import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

import { PlanListPlanIdCell } from '../components/PlanListPlanIdCell';
import { IKnmPlan } from '../interfaces/IKnmPlan';

export const initialPlanListTableColumns: ITableColumn<IKnmPlan>[] = [
  {
    id: 'id',
    name: '№ плана',
    sort: TableColumnSortEnum.NONE,
    renderCell: PlanListPlanIdCell,
  },
  {
    id: 'prosecName',
    name: 'Прокуратура',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'knoName',
    name: 'Контролирующий орган',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'period',
    name: 'Период проведения',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'type',
    name: 'Тип плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'status',
    name: 'Статус плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'knmAmount',
    name: 'Число проверок плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'disapprovedKnmAmount',
    name: 'Число отклоненных проверок плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'createdBy',
    name: 'Автор',
    sort: TableColumnSortEnum.NONE,
    nestedId: 'fullName',
  },
  {
    id: 'updatedBy',
    name: 'Автор последнего изменения',
    sort: TableColumnSortEnum.NONE,
    nestedId: 'fullName',
  },
  {
    id: 'created',
    name: 'Дата создания плана',
    sort: TableColumnSortEnum.DESC,
  },
  {
    id: 'updated',
    name: 'Дата последнего изменения плана',
    sort: TableColumnSortEnum.NONE,
  },
  {
    id: 'creationType',
    name: 'Способ подачи',
    sort: TableColumnSortEnum.NONE,
  },
];
